import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    [types.ADD_OR_UPDATE_TASK]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_TASK]: (state, item) => removeItem(state, item),
    [types.SET_TASKS_TOTAL]: (state, total) => state.total = total
}